import React from 'react'
import { MdErrorOutline } from 'react-icons/md'

const NotificationContent = () => {
  return (
    <>
      <MdErrorOutline
        color="#721c24"
        size={`1.5em`}
        style={{
          minWidth: '20px',
          position: 'absolute',
          left: '6px',
          top: '12px',
        }}
      />
      <div className="ml-3">
        <div className="mb-1" style={{ fontWeight: 900 }}>
          This website works best in the latest versions of Chrome, Edge,
          Firefox, and similar browsers. You may not have the best experience on
          your current browser or device.
        </div>
      </div>
    </>
  )
}

export default NotificationContent
